import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { BillDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Bills/bill-dto';
import { OrderDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/OrderV2/order-dto';
import { OrderV2Service } from 'src/api/generated/services';
import { OrdersFilterComponent } from './orders-filter/orders-filter.component';
import { OrderSearchModel } from './orders-filter/order-search.model';
import { BillSearchModel } from './bills-filter/bill-search.model';
import { BillsFilterComponent } from './bills-filter/bills-filter.component';
import { TableDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Group/table-dto';
import { EmployeeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Employee/employee-dto';
import { GroupDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Group/group-dto';
import { PrinterTypeEnum } from 'src/app/waiter-panel/enums/printer-type.enum';
import { GetFilteredOrdersPaginated$Params } from 'src/api/generated/fn/order-v-2/get-filtered-orders-paginated';
import { GetOrdersPaginatedDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/OrderV2/get-orders-paginated-dto';
import { GetBillsPaginatedDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/OrderV2/get-bills-paginated-dto';
import { GetFilteredBillsPaginated$Params } from 'src/api/generated/fn/order-v-2/get-filtered-bills-paginated';
import { GetBillsForManagerSummarized$Params } from 'src/api/generated/fn/order-v-2/get-bills-for-manager-summarized';
import { BillsSummarizedDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Bills/bills-summarized-dto';
import { BillStatusEnum, BillStatuses } from 'src/app/pos-panel/enums/bill-statuses.enum';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { Observable, Subscription, combineLatest, forkJoin } from 'rxjs';
import { CurrencyService } from 'src/app/pos-panel/services/currency-helper/currency.service';
import { Currency } from 'src/api/generated/models/Digiwork/MaitreD/Domen/Model/currency';
import * as moment from 'moment';

@Component({
  selector: 'app-turnover-records',
  templateUrl: './turnover-records.component.html',
  styleUrls: ['./turnover-records.component.scss']
})
export class TurnoverRecordsComponent implements OnInit, OnDestroy {

  activeIndex: number = 0;
  venueId: string;

  orders: Array<OrderDto> | null | undefined;
  orderSearch: OrderSearchModel;

  billSearch: BillSearchModel;
  bills: Array<BillDto> | null | undefined;

  PrinterTypeEnum = PrinterTypeEnum;

  expandOrderSearchFilters: boolean = false;
  expandBillSearchFilters: boolean = false;

  billSummary: BillsSummarizedDto;
  paidFiscal: number = 0;
  paidThermal: number = 0;
  unpaidFiscal: number = 0;
  unpaidThermal: number = 0;

  ordersPageSize: number = 10;
  ordersCurrentPage: number = 1;
  ordersTotalItems: number;
  ordersTotalPages: number;
  loadingOrders: boolean = true;

  billsPageSize: number = 10;
  billsCurrentPage: number = 1;
  billsTotalItems: number;
  billsTotalPages: number;
  loadingBills: boolean = false;

  ordersDate: any;
  billsDate: any;
  BillStatusEnum = BillStatusEnum;
  BillStatus = BillStatuses;

  currency: Currency;

  venueIdUpdateSubscription: Subscription;
  timezoneOffset: any;

  constructor(private route: ActivatedRoute,
              public router: Router,
              public orderService: OrderV2Service,
              public currentVenueHelper: CurrentVenueHelperService,
              private dialogService: DialogService,
              public currencyService: CurrencyService) { 

      this.orderSearch = new OrderSearchModel();
      this.billSearch = new BillSearchModel();

      this.ordersDate = new Date();
      this.billsDate = new Date();
      this.currencyService.currencyObservable().subscribe(currency => this.currency = currency);

      this.route.params.subscribe(params => {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      });

      this.route.queryParams.subscribe(queryParams => {
        if(queryParams['activeIndex']){
          this.activeIndex = queryParams['activeIndex'];
        }
        if(queryParams['ordersFrom']){
          this.ordersDate = new Date(queryParams['ordersFrom']);
        }
        if(queryParams['ordersFrom'] && queryParams['ordersFrom'].includes('T')){
          this.orderSearch.from = this.ordersDate;
        }
        if(queryParams['ordersUntil']){
          this.orderSearch.until = new Date(queryParams['ordersUntil']);
        }
        if(queryParams['billsFrom']){
          this.billsDate = new Date(queryParams['billsFrom']);
        }
        if(queryParams['billsFrom'] && queryParams['billsFrom'].includes('T')){
          this.billSearch.from = this.billsDate;
        }
        if(queryParams['billsUntil']){
          this.billSearch.until = new Date(queryParams['billsUntil']);
        } 
        if(this.timezoneOffset != undefined){
          this.refreshData();   
        } 
      });

      this.currentVenueHelper.getTimezone().subscribe(timezone => {
        if(timezone != undefined && timezone != this.timezoneOffset){
          this.timezoneOffset = timezone;
          this.refreshData();
        }
      });

    }

  ngOnInit(): void {

  }
  onOrdersPageChange(event: any){
    if(this.ordersPageSize != event.rows){
      this.ordersPageSize = event.rows;
    }
    this.ordersCurrentPage =  event.first / event.rows + 1 ; 
    this.loadOrders();
  }

  loadOrders(){
    this.loadingOrders = true;
    let getDto: GetOrdersPaginatedDto = { venueId : this.venueId };

    getDto.startTime = this.orderSearch.from ? moment(this.orderSearch.from).utcOffset(this.timezoneOffset, true).toISOString() : moment(this.ordersDate).utcOffset(this.timezoneOffset, true).startOf('day').toISOString();
    getDto.endTime = this.orderSearch.until ? moment(this.orderSearch.until).utcOffset(this.timezoneOffset, true).toISOString() : moment(this.ordersDate).utcOffset(this.timezoneOffset, true).endOf('day').toISOString();

    if(this.orderSearch.tables && this.orderSearch.tables.length > 0 ){
      getDto.tableNames = [];
      this.orderSearch.tables.forEach(t => {
          getDto.tableNames?.push(t);
        });
    }
    if(this.orderSearch.waiters && this.orderSearch.waiters.length > 0 ){
      getDto.waiterIds = [];
      this.orderSearch.waiters.forEach(w => {
        if(w.userId){
          getDto.waiterIds?.push(w.userId);
        }});
    }
    if(this.orderSearch.groups && this.orderSearch.groups.length > 0 ){
      getDto.groupIds = [];
      this.orderSearch.groups.forEach(g => {
        if(g.id){
          getDto.groupIds?.push(g.id);
        }});    
    }
    if(this.orderSearch.orderNumbers){
      getDto.orderNumbers = [];
      getDto.orderNumbers.push(this.orderSearch.orderNumbers);
    }
    if(this.orderSearch.orderType != undefined ){
      getDto.orderType = this.orderSearch.orderType;
    }

    getDto.pageNumber = this.ordersCurrentPage;
    getDto.pageSize = this.ordersPageSize;

    let getParams: GetFilteredOrdersPaginated$Params = { body: getDto };
    this.orderService.getFilteredOrdersPaginated(getParams).subscribe(response => {
      this.loadingOrders = false;
      this.orders = response.data;
      this.ordersTotalPages = response.totalPages ? response.totalPages : 0;
      this.ordersTotalItems = response.totalRecords ? response.totalRecords : 0;
    });
  }

  changeURL(){
    let queryParams: { [key: string]: any } = {};
    queryParams.activeIndex = this.activeIndex;
    queryParams.ordersFrom = this.orderSearch.from ? moment(new Date(this.orderSearch.from).setSeconds(0)).toISOString() : moment(this.ordersDate).format('YYYY-MM-DD');
    queryParams.ordersUntil = this.orderSearch.until ? moment(new Date(this.orderSearch.until).setSeconds(0)).toISOString() : null;
  
    queryParams.billsFrom = this.billSearch.from ? moment(new Date(this.billSearch.from).setSeconds(0)).toISOString() : moment(this.billsDate).format('YYYY-MM-DD');
    queryParams.billsUntil = this.billSearch.until ? moment(new Date(this.billSearch.until).setSeconds(0)).toISOString() : null;
    this.router.navigate([this.venueId, "turnover"], { queryParams: queryParams, queryParamsHandling: 'merge' });
  }

  onBillsPageChange(event: any){
    if(this.billsPageSize != event.rows){
      this.billsPageSize = event.rows;
    }
    this.billsCurrentPage =  event.first / event.rows + 1 ;
    this.loadBills();
  }


  loadBills(){
    this.loadingBills = true;
    let getDto: GetBillsPaginatedDto = { venueId : this.venueId };

    getDto.startTime = this.billSearch.from ? moment(this.billSearch.from).utcOffset(this.timezoneOffset, true).toISOString() :  moment(this.billsDate).utcOffset(this.timezoneOffset, true).startOf('day').toISOString();
    getDto.endTime = this.billSearch.until ? moment(this.billSearch.until).utcOffset(this.timezoneOffset, true).toISOString() :  moment(this.billsDate).utcOffset(this.timezoneOffset, true).endOf('day').toISOString();

    if(this.billSearch.tables && this.billSearch.tables.length > 0 ){
      getDto.tableNames = [];
      this.billSearch.tables.forEach(t => {
          getDto.tableNames?.push(t);
        });
    }
    if(this.billSearch.waiters && this.billSearch.waiters.length > 0 ){
      getDto.waiterIds = [];
      this.billSearch.waiters.forEach(w => {
        if(w.userId){
          getDto.waiterIds?.push(w.userId);
        }});
    }
    if(this.billSearch.groups && this.billSearch.groups.length > 0 ){
      getDto.groupIds = [];
      this.billSearch.groups.forEach(g => {
        if(g.id){
          getDto.groupIds?.push(g.id);
        }});    
    }
    if(this.billSearch.billNumber){
      getDto.billNumbers = [];
      getDto.billNumbers.push(this.billSearch.billNumber);
    }
    if(this.billSearch.billStatuses && this.billSearch.billStatuses.length > 0 ){
      getDto.billStatuses = this.billSearch.billStatuses;
    }
    
    getDto.pageNumber = this.billsCurrentPage;
    getDto.pageSize = this.billsPageSize;

    let getParams: GetFilteredBillsPaginated$Params = { body: getDto };

    this.orderService.getFilteredBillsPaginated(getParams).subscribe((response: any) => {
      this.loadingBills = false;;
      this.bills = response.data;
      this.billsTotalItems = response.totalRecords ? response.totalRecords : 0;
      this.billsTotalPages = response.totalPages ? response.totalPages : 0;
    });

    const getParamsForSummary: GetBillsForManagerSummarized$Params = { body: getDto };
    this.orderService.getBillsForManagerSummarized(getParamsForSummary).subscribe(response => {
      this.billSummary = response;
      this.paidFiscal = 0;
      if(this.billSummary.paidNetAmountFiscal){
        this.paidFiscal += this.billSummary.paidNetAmountFiscal;
      }
      if(this.billSummary.paidTaxAmountFiscal){
        this.paidFiscal += this.billSummary.paidTaxAmountFiscal;
      }
      this.unpaidFiscal = 0;
      if(this.billSummary.unpaidNetAmountFiscal){
        this.unpaidFiscal += this.billSummary.unpaidNetAmountFiscal;
      }
      if(this.billSummary.unpaidTaxAmountFiscal){
        this.unpaidFiscal += this.billSummary.unpaidTaxAmountFiscal;
      }
      this.paidThermal = 0;
      if(this.billSummary.paidNetAmountThermal){
        this.paidThermal += this.billSummary.paidNetAmountThermal;
      }
      if(this.billSummary.paidTaxAmountThermal){
        this.paidThermal += this.billSummary.paidTaxAmountThermal;
      }
      this.unpaidThermal = 0;
      if(this.billSummary.unpaidNetAmountThermal){
        this.unpaidThermal += this.billSummary.unpaidNetAmountThermal;
      }
      if(this.billSummary.unpaidTaxAmountThermal){
        this.unpaidThermal += this.billSummary.unpaidTaxAmountThermal;
      }
    })
  }

  onOrderDateChange(){
    if(this.orderSearch.from){
      let hours = this.orderSearch.from.getHours();
      let minutes = this.orderSearch.from.getMinutes();
      this.orderSearch.from = new Date(this.ordersDate);
      this.orderSearch.from.setHours(hours);
      this.orderSearch.from.setMinutes(minutes);
    }
    if(this.orderSearch.until){
      let hours = this.orderSearch.until.getHours();
      let minutes = this.orderSearch.until.getMinutes();
      this.orderSearch.until = new Date(this.ordersDate);
      this.orderSearch.until.setHours(hours);
      this.orderSearch.until.setMinutes(minutes);
    }
    if(this.orderSearch.from && this.orderSearch.until && (this.orderSearch.from > this.orderSearch.until) ){
      this.orderSearch.until.setDate(this.orderSearch.until.getDate() + 1);
   }
    this.ordersCurrentPage = 1;
    this.changeURL();
  }
  onBillDateChange(){
    if(this.billSearch.from){
      let hours = this.billSearch.from.getHours();
      let minutes = this.billSearch.from.getMinutes();
      this.billSearch.from = new Date(this.billsDate);
      this.billSearch.from.setHours(hours);
      this.billSearch.from.setMinutes(minutes);
    }
    if(this.billSearch.until){
      let hours = this.billSearch.until.getHours();
      let minutes = this.billSearch.until.getMinutes();
      this.billSearch.until = new Date(this.billsDate);
      this.billSearch.until.setHours(hours);
      this.billSearch.until.setMinutes(minutes);
    }
    if(this.billSearch.from && this.billSearch.until && (this.billSearch.from > this.billSearch.until) ){
      this.billSearch.until.setDate(this.billSearch.until.getDate() + 1);
    }
    this.billsCurrentPage = 1;
    this.changeURL();
  }

  refreshData(){
    if (this.activeIndex == 0) {
      this.loadOrders();
    } else if (this.activeIndex == 1){
        this.loadBills();
    } 
  }
  
  filterOrders(){
    
    const ref = this.dialogService.open(OrdersFilterComponent, {
      showHeader: false,
      data: {
        venueId: this.venueId,
        model: this.orderSearch,
        date: this.ordersDate
      }
    });
    ref.onClose.subscribe(response => {
      if(response){
        this.orderSearch = response;
        this.changeURL();
        this.refreshData();
      }
    });
  }

  orderDetials(order: OrderDto){
    this.router.navigate([this.venueId, 'turnover', 'orders', order.id]);
  }

  filterBills(){
    const ref = this.dialogService.open(BillsFilterComponent, {
      showHeader: false,
      data: {
        venueId: this.venueId,
        date: this.billsDate,
        model: this.billSearch
      }
    });
    ref.onClose.subscribe(response => {
      if(response){
        this.billSearch = response;
        this.changeURL();
        this.refreshData();
      }
    });
  }

  billDetails(bill: BillDto){
    this.router.navigate([this.venueId, 'turnover', 'bills', bill.id]);
  }

  changeTab(e: any) {
    this.activeIndex = e.index;
    this.router.navigate([], 
      {
        relativeTo: this.route,
        queryParams:{ activeIndex: this.activeIndex }, 
        queryParamsHandling: 'merge',
      });
  }
  showOrderSearchKeywords(){
    return (this.orderSearch.orderNumbers) || 
            (this.orderSearch.orderType != undefined) ||
            (this.orderSearch.from) || (this.orderSearch.until) ||
           (this.orderSearch.tables && this.orderSearch.tables.length > 0) ||
           ( this.orderSearch.waiters && this.orderSearch.waiters.length > 0) || 
           (this.orderSearch.groups?.length && this.orderSearch.groups.length > 0);   
  }
  resetOrders(){
    this.ordersCurrentPage = 1;
    this.loadOrders();
  }
  clearOrderTableSearch(item: String){
    this.orderSearch.tables = this.orderSearch.tables?.filter(table => table != item);
    this.resetOrders();
  }
  clearOrderWaiterSearch(item: EmployeeDto){
    this.orderSearch.waiters = this.orderSearch.waiters?.filter(waiter => waiter.userId != item.userId);
    this.resetOrders();
  }
  clearOrderTimeSelection(){
    this.orderSearch.from = undefined;
    this.orderSearch.until = undefined;
    this.changeURL();
    this.resetOrders();
  }
  clearOrderTimeSelectionFrom(){
    this.orderSearch.from = undefined;
    this.changeURL();
    this.resetOrders();
  }
  clearOrderTimeSelectionUntil(){
    this.orderSearch.until = undefined;
    this.changeURL();
    this.resetOrders();
  }
  clearOrderNumberSearch(){
    this.orderSearch.orderNumbers = undefined;
    this.resetOrders();
  }
  clearOrderGroupsSearch(item: GroupDto){
    this.orderSearch.groups = this.orderSearch.groups?.filter(group => group.id != item.id);
    this.resetOrders();
  }
  clearOrderOrderTypeSearch(){
    this.orderSearch.orderType = undefined; //this.orderSearch.orderType?.filter(orderType => orderType != item);
    this.resetOrders();
  }
  clearOrderFilters(){
    this.expandOrderSearchFilters = false;
    this.orderSearch = new OrderSearchModel();
    this.resetOrders();
    this.changeURL();
  }

  showBillSearchKeywords(){
    return  (this.billSearch.billNumber) || 
            (this.billSearch.billStatuses && this.billSearch.billStatuses.length > 0) ||
            (this.billSearch.from) || (this.billSearch.until) ||
            (this.billSearch.tables && this.billSearch.tables.length > 0) ||
            (this.billSearch.waiters && this.billSearch.waiters.length > 0) || 
            (this.billSearch.groups?.length && this.billSearch.groups.length > 0);     
  }

  clearBillFilters(){
    this.expandBillSearchFilters = false;
    this.billSearch = new BillSearchModel();
    this.resetBills();
    this.changeURL();
  }

  resetBills(){
    this.billsCurrentPage = 1;
    this.loadBills();
  }
 
  clearBillTableSearch(item: string){
    this.billSearch.tables = this.billSearch.tables.filter(table => table != item);
    this.resetBills();
  }
  clearBillWaiterSearch(item: EmployeeDto){
    this.billSearch.waiters = this.billSearch.waiters.filter(waiter => waiter.userId != item.userId);
    this.resetBills();
  }
  clearBillTimeSelection(){
    this.billSearch.from = undefined;
    this.billSearch.until = undefined;
    this.resetBills();
    this.changeURL();
  }
  clearBillTimeSelectionFrom(){
    this.billSearch.from = undefined;
    this.resetBills();
    this.changeURL();
  }
  clearBillTimeSelectionUntil(){
    this.billSearch.until = undefined;
    this.resetBills();
    this.changeURL();
  }
  clearBillNumberSearch(){
    this.billSearch.billNumber = undefined;
    this.resetBills();
  }
  clearBillStatusSearch(item: any){
      this.billSearch.billStatuses = this.billSearch.billStatuses?.filter(status => status != item);
      this.resetBills();
  }
  clearBillGroupsSearch(item: GroupDto){
    this.billSearch.groups = this.billSearch.groups?.filter(group => group.id != item.id);
    this.resetBills();
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
